module.exports = __webpack_public_path__ + "static/media/list.0ac9c7a4.svg";